// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");

function paragraphWordOffset_encode(v) {
  return Js_dict.fromArray([
              [
                "nthParagraph",
                Decco.intToJson(v.nthParagraph)
              ],
              [
                "wordIndex",
                Decco.intToJson(v.wordIndex)
              ],
              [
                "offset",
                Decco.intToJson(v.offset)
              ]
            ]);
}

function paragraphWordOffset_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var nthParagraph = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nthParagraph"), null));
  if (nthParagraph.TAG === /* Ok */0) {
    var wordIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "wordIndex"), null));
    if (wordIndex.TAG === /* Ok */0) {
      var offset = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "offset"), null));
      if (offset.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  nthParagraph: nthParagraph._0,
                  wordIndex: wordIndex._0,
                  offset: offset._0
                }
              };
      }
      var e = offset._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".offset" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = wordIndex._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".wordIndex" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = nthParagraph._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".nthParagraph" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function paragraphWord_encode(v) {
  return Js_dict.fromArray([
              [
                "nthParagraph",
                Decco.intToJson(v.nthParagraph)
              ],
              [
                "wordIndex",
                Decco.intToJson(v.wordIndex)
              ]
            ]);
}

function paragraphWord_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var nthParagraph = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nthParagraph"), null));
  if (nthParagraph.TAG === /* Ok */0) {
    var wordIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "wordIndex"), null));
    if (wordIndex.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                nthParagraph: nthParagraph._0,
                wordIndex: wordIndex._0
              }
            };
    }
    var e = wordIndex._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".wordIndex" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = nthParagraph._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".nthParagraph" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function semanticError_encode(v) {
  switch (v.TAG | 0) {
    case /* CouldNotFindNthParagraph */0 :
        return [
                "CouldNotFindNthParagraph",
                Decco.intToJson(v._0)
              ];
    case /* CouldNotFindWordAtIndexInNthParagraph */1 :
        return [
                "CouldNotFindWordAtIndexInNthParagraph",
                paragraphWord_encode(v._0)
              ];
    case /* CouldNotFindOffsetInsideWordInNthParagraph */2 :
        return [
                "CouldNotFindOffsetInsideWordInNthParagraph",
                paragraphWordOffset_encode(v._0)
              ];
    
  }
}

function semanticError_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CouldNotFindNthParagraph" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CouldNotFindNthParagraph */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "CouldNotFindOffsetInsideWordInNthParagraph" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = paragraphWordOffset_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CouldNotFindOffsetInsideWordInNthParagraph */2,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "CouldNotFindWordAtIndexInNthParagraph" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = paragraphWord_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CouldNotFindWordAtIndexInNthParagraph */1,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

exports.paragraphWordOffset_encode = paragraphWordOffset_encode;
exports.paragraphWordOffset_decode = paragraphWordOffset_decode;
exports.paragraphWord_encode = paragraphWord_encode;
exports.paragraphWord_decode = paragraphWord_decode;
exports.semanticError_encode = semanticError_encode;
exports.semanticError_decode = semanticError_decode;
/* No side effect */
